import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import KeybindsTab from "../tabs/helpDialogTabs/KeybindsTab";
import React from "react";

export default function HelpDialog({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (value: React.SetStateAction<boolean>) => void;
}) {
  const [tabValue, setTabValue] = React.useState(0);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth={true}
      maxWidth={false}
      style={{
        width: "80vw",
        position: "fixed",
        left: "50%",
        transform: "translate(-50%, 0)",
      }}
      componentsProps={{
        backdrop: { invisible: true }, // make the backdrop invisible
      }}
    >
      <DialogTitle style={{ display: "flex", justifyContent: "center" }}>
        Help
      </DialogTitle>
      <DialogContent style={{ width: "100vw" }}>
        <div style={{ display: "flex" }}>
          <div style={{ maxHeight: "50vh", overflow: "auto" }}>
            <Tabs
              value={tabValue}
              onChange={(event, newValue) => setTabValue(newValue)}
              orientation="vertical"
              style={{
                backgroundColor: "#111111",
                padding: 8,
                paddingLeft: 0,
                zIndex: 2,
              }}
              TabIndicatorProps={{
                style: {
                  backgroundColor: "blue",
                },
              }}
            >
              <Tab label="Keybinds" style={{ color: "white" }} value={0} />
              <Tab label="Placeholder" style={{ color: "white" }} value={1} />
              <Tab label="Placeholder" style={{ color: "white" }} value={2} />
              <Tab label="Placeholder" style={{ color: "white" }} value={3} />
            </Tabs>
          </div>
          <CustomTabPanel value={tabValue} index={0}>
            <KeybindsTab />
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={1}>
            <div> tab panel 2</div>
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={2}>
            <div> tab panel 3</div>
          </CustomTabPanel>
          <CustomTabPanel value={tabValue} index={3}>
            <div> tab panel 4</div>
          </CustomTabPanel>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          variant="outlined"
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }} hidden={value !== index}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
